import { IAnimateEmojiProps } from "interfaces";
import Emoji from "../../../emoji/emoji";

const AnimatedEmoji = ({ emojiCode, direction }: IAnimateEmojiProps) => {
    return (
        <div
            className={`pl-absolute ${direction === "RIGHT" ? "pl-right-3" : "pl-left-3"} pl-w-[32px] pl-h-[32px] pl-cursor-auto pl-bottom-14 ${
                direction === "RIGHT" ? "pl-uni-first-line-emoji-right" : "pl-uni-first-line-emoji-left"
            }`}
        >
            <Emoji name={emojiCode} className="pl-cursor-auto" />
        </div>
    );
};

export default AnimatedEmoji;
